<template>
  <div>
    <presentacion-modulo-app :datos="data"></presentacion-modulo-app>
    
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 2/AUDIO 01'
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {
        "titulo": "",
        "nombreModulo": "Módulo 2" ,
        "texto": "Clasificación de las reservas"
      }
    }
  },
  created() {
    this.$store.commit('nextShow', true)
  }
}
</script>
